/* eslint-disable react/prop-types */
import React from "react";
import { Link } from "@quintype/components";
import "./collection-name.m.css";
import Arrow from "../../atoms/other-icons/Arrow";

const CollectionName = ({ collection, isSeeMore }) => {
  const name = collection.name;
  return (
    <div className="collection-name" styleName="wrapper">
      <h1>{name}</h1>
      {isSeeMore ? (
        <Link href={`/${collection.slug}`} styleName="seemore-link" className="headline-link">
          <div styleName="seemore">
            <span styleName="more">ಇನ್ನಷ್ಟು </span>
            <span styleName="right-arrow">
              <Arrow color="#b82831" width="16px" height="16px" />
            </span>
          </div>
        </Link>
      ) : null}
    </div>
  );
};

CollectionName.defaultProps = {
  isSeeMore: true
};

export default CollectionName;
